import React from "react";
import { Link } from "react-router-dom";

export default function TemplateRow({ item, displayNo }) {
  return (
    <div className="regul-template-row">
      <div className="regul-template-col-no">{displayNo}</div>

      <div className="regul-template-col-title">
        <Link
          to={`/documents/student-council/regulations/${item.id}`}
          className="regul-template-title-link"
        >
          {item.title}
        </Link>
      </div>

      <div className="regul-template-col-writer">{item.writer}</div>
      <div className="regul-template-col-date">{item.date}</div>
      <div className="regul-template-col-view">{item.view}</div>
    </div>
  );
}